<div class="contents-area">
  <div class="element-column">
    <div>
      <h2>提案対象企画回・特集</h2>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">企画回</label>
          <div class="list-input-content">
            <input type="text" #tbx_CatalogId id="tbx_CatalogId" [(ngModel)]="model.catalogId" [style.width.rem]="15"
              [tabindex]="0" forcedEnabledMode="" plessInputTextSub readonly/>
          </div>
        </div>

        <div class="column-list">
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <input type="text" #tbx_MediumName id="tbx_MediumName" [(ngModel)]="model.mediumName" [style.width.rem]="15"
              [tabindex]="0" forcedEnabledMode="" plessInputTextSub readonly/>
          </div>
        </div>

        <div class="column-list">
          <label class="list-input-title">特集指定</label>
          <div class="list-input-content">
            <input type="text" #tbx_Feature id="tbx_Feature" [(ngModel)]="model.feature" [style.width.rem]="15"
              [tabindex]="0" forcedEnabledMode="" plessInputTextSub readonly/>
          </div>
        </div>
      </div>
    </div>

    <div class="layout_balance">
      <button #btn_SearchGoods id="btn_SearchGoods" class="btn-secondary" [tabindex]="0"
        [disabled]="model.isDisableButtonSearchGoods" (click)="eventSearchGoods_CLICKHandler()">
        商品検索</button>
      <button #btn_ToggleView id="btn_ToggleView" class="btn-secondary" [tabindex]="0"
        [disabled]="model.isDisableButtonToggleView" (click)="eventToggleView_CLICKHandler()">
        表示切替</button>
    </div>
  </div>

  <div class="element-column" [hidden]="model.isHiddenCandidateList">
    <div>
      <h1>提案候補商品一覧</h1>
      <div class="action-area">
        <app-pager [prevDisabled]="(model.currentPageNoCandidateList <= 1)"
          [nextDisabled]="(model.currentPageNoCandidateList >= model.endPageNoCandidateList)"
          [totalNum]="model.totalNumCandidateList" [startNum]="model.startDispNumCandidateList"
          [endNum]="model.endDispNumCandidateList" (prevHandler)="eventBackHandlerCandidateList()"
          (nextHandler)="eventNextHandlerCandidateList()">
        </app-pager>
      </div>

      <!-- データグリッド定義 提案候補商品一覧" -->
      <wj-flex-grid #dtg_CandidateSuggestionGoodsList id="dtg_CandidateSuggestionGoodsList"
        [itemsSource]="model.candidateSuggestionGoodsPageList" [tabindex]="0" [frozenColumns]="2"
        [selectionMode]="'Row'" [headersVisibility]="'Column'" [isReadOnly]="false" [allowDragging]="'None'"
        [allowSorting]="false">
        <wj-flex-grid-column [minWidth]="5" [width]="45" [header]="' '" [binding]="'check'" [align]="'center'"
          [isReadOnly]="true">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input type="checkbox" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"/>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="110" [isReadOnly]="true" [header]="'Ｐコード'"
          [binding]="'PCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="110" [isReadOnly]="true" [header]="'アイテムコード'"
          [binding]="'ItemCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [isReadOnly]="true" [header]="'JANコード'"
          [binding]="'JanCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="270" [isReadOnly]="true" [header]="'商品案内用商品名'"
          [binding]="'GuideGoodsName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="180" [isReadOnly]="true" [header]="'商品案内用規格名'"
          [binding]="'GuideStandardName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="357" [isReadOnly]="true" [header]="'メーカー名'"
          [binding]="'MakerName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="250" [isReadOnly]="true" [header]="'訂正元eBaseNo'"
          [binding]="'EBaseSpecCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="130" [isReadOnly]="true" [header]="'過去企画回'"
          [binding]="'CatalogId'"></wj-flex-grid-column>
      </wj-flex-grid>
    </div>

    <button #btn_SelectGoods id="btn_SelectGoods" class="btn-secondary" [tabindex]="0"
      [disabled]="model.isDisableButtonSelectGoods" (click)="eventSelectGoods_CLICKHandler()">
      選定</button>
  </div>

  <div class="element-column">
    <div>
      <h1>提案商品一覧</h1>
      <div class="action-area">
        <app-pager [prevDisabled]="model.currentPageNoSuggestList <= 1"
          [nextDisabled]="(model.currentPageNoSuggestList >= model.endPageNoSuggestList)"
          [totalNum]="model.totalNumSuggestList" [startNum]="model.startDispNumSuggestList"
          [endNum]="model.endDispNumSuggestList" (prevHandler)="eventBackHandlerSuggestList()"
          (nextHandler)="eventNextHandlerSuggestList()">
        </app-pager>
      </div>

      <!-- データグリッド定義 提案商品一覧" -->
      <wj-flex-grid #dtg_SuggestionGoodsList id="dtg_SuggestionGoodsList" [itemsSource]="model.suggestionGoodsPageList"
        [tabindex]="0" [frozenColumns]="2" [selectionMode]="'Row'" [headersVisibility]="'Column'" [isReadOnly]="false"
        [allowDragging]="'None'" [allowSorting]="false" [style.height]="model.isHiddenCandidateList ? '63vh' : '240px'">
        <wj-flex-grid-column [minWidth]="5" [width]="45" [header]="' '" [binding]="'check'" [align]="'center'"
          [isReadOnly]="true">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input type="checkbox" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"
              [disabled]="model.isDisableGridColumnsSuggestList">
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="110" [isReadOnly]="true" [header]="'Ｐコード'" [binding]="'PCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="110" [isReadOnly]="true" [header]="'アイテムコード'" [binding]="'ItemCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [isReadOnly]="true" [header]="'JANコード'" [binding]="'JanCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="270" [isReadOnly]="true" [header]="'商品案内用商品名'" [binding]="'GuideGoodsName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="180" [isReadOnly]="true" [header]="'商品案内用規格名'" [binding]="'GuideStandardName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="350" [isReadOnly]="true" [header]="'メーカー名'" [binding]="'MakerName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="110" [isReadOnly]="true" [header]="'価格パターン'" [binding]="'PricePattern'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <app-versatile-combo-box *ngIf="model.isEditableColumnSuggestList; else elseBlock"
              [disabled]="model.isDisableGridColumnsSuggestList"
              [style.width.px]="150" forcedEnabledMode="true" [tabindex]="0" [autofocus]="false"
              [listSource]="pricePatternList" valueField="value" labelField="label" [required]="pricePatternRequired"
              [(ngModel)]="cell.item.PricePattern" (change)="eventPricePattern_CHANGEHandler(cell.item)">
            </app-versatile-combo-box>
            <ng-template #elseBlock>
              <div>{{ cell.item.PricePattern | pricePattern }}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'供給価格(通常)'" [binding]="'SupplyPriceStandard'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'今回供給価格'" [binding]="'ThisTimeSupplyPriceStandard'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input *ngIf="model.isEditableColumnSuggestList; else elseBlock" type="text"
              [disabled]="model.isDisableGridColumnsSuggestList"
              class="embedded-input type-number" [maxlength]="8" [tabindex]="0"
              plessInputTextSub [restrict]="'[0-9]'" [ngClass]="thisTimeSupplyPriceStandardRequired ? 'text-label-required': 'text-label-normal'"
              [(ngModel)]="cell.item.ThisTimeSupplyPriceStandard">
            <ng-template #elseBlock>
              <div>{{cell.item.ThisTimeSupplyPriceStandard}}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'仕入価格(通常)'" [binding]="'CostPriceStandard'"
          [visible]="model.isVisibleColumnCostPriceStandard"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'今回仕入価格'" [binding]="'ThisTimeCostPriceStandard'"
          [visible]="model.isVisibleColumnThisTimeCostPriceStandard">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input *ngIf="model.isEditableColumnSuggestList; else elseBlock" type="text"
              [disabled]="model.isDisableGridColumnsSuggestList"
              class=" embedded-input type-number" [maxlength]="10" [tabindex]="0"
              plessInputTextSub [restrict]="'[.0-9]'" [ngClass]="thisTimeCostPriceStandardRequired ? 'text-label-required': 'text-label-normal'"
              [(ngModel)]="cell.item.ThisTimeCostPriceStandard">
            <ng-template #elseBlock>
              <div>{{cell.item.ThisTimeCostPriceStandard}}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'在庫数'" [binding]="'StockNum'"
          [visible]="model.isVisibleColumnStockNumd">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input *ngIf="model.isEditableColumnSuggestList; else elseBlock" type="text"
              [disabled]="model.isDisableGridColumnsSuggestList"
              class="embedded-input type-number" [maxlength]="7" [tabindex]="0"
              plessInputTextSub [restrict]="'[0-9]'" [ngClass]="stockNumRequired ? 'text-label-required': 'text-label-normal'"
              [(ngModel)]="cell.item.StockNum">
            <ng-template #elseBlock>
              <div>{{cell.item.StockNum}}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="225" [isReadOnly]="true" [header]="'発注単位'"
          [binding]="'OrderUnitType'" [visible]="model.isVisibleColumnOrderUnitType">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <app-versatile-combo-box *ngIf="model.isEditableColumnSuggestList; else elseBlock"
              [disabled]="model.isDisableGridColumnsSuggestList"
              [style.width.px]="150" forcedEnabledMode="true" [tabindex]="0" [autofocus]="false"
              [listSource]="model.orderUnitTypeList" valueField="value" labelField="label" [required]="orderUnitTypeRequired"
              [(ngModel)]="cell.item.OrderUnitType" (change)="eventOrderUnitType_CHANGEHandler(cell.item.OrderUnitType)">
            </app-versatile-combo-box>
            <ng-template #elseBlock>
              <div>{{ cell.item.OrderUnitType | orderUnitType : model.orderUnitTypeList }}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="80" [isReadOnly]="true" [header]="'新規区分'"
          [binding]="'NewUnitType'" [visible]="model.isVisibleColumnNewUnitType">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <app-versatile-combo-box *ngIf="model.isEditableColumnSuggestList; else elseBlock"
              [disabled]="model.isDisableGridColumnsSuggestList"
              [style.width.px]="150" forcedEnabledMode="true" [tabindex]="0" [autofocus]="false"
              [listSource]="newUnitTypeList" valueField="value" labelField="label" [required]="newUnitTypeRequired"
              [(ngModel)]="cell.item.NewUnitType" (change)="eventNewUnitType_CHANGEHandler(cell.item.NewUnitType)">
            </app-versatile-combo-box>
            <ng-template #elseBlock>
              <div>{{ cell.item.NewUnitType | newUnitType }}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'計画数'" [binding]="'PlanNum'"
          [visible]="model.isVisibleColumnPlanNum">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input *ngIf="model.isEditableColumnSuggestList; else elseBlock" type="text"
              [disabled]="model.isDisableGridColumnsSuggestList"
              class="embedded-input type-number" [maxlength]="7" [tabindex]="0"
              plessInputTextSub [restrict]="'[0-9]'" [ngClass]="planNumRequired ? 'text-label-required': 'text-label-normal'"
              [(ngModel)]="cell.item.PlanNum">
            <ng-template #elseBlock>
              <div>{{cell.item.PlanNum}}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'注文番号'" [binding]="'OrderNum'"
          [visible]="model.isVisibleColumnOrderNum">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input *ngIf="model.isEditableColumnSuggestList; else elseBlock" type="text"
              [disabled]="model.isDisableGridColumnsSuggestList"
              class="text-label-normal embedded-input" [maxlength]="6" [tabindex]="0"
              [(ngModel)]="cell.item.OrderNum" plessInputTextSub [restrict]="'[ -￮]'" >
            <ng-template #elseBlock>
              <div>{{cell.item.OrderNum}}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="240" [isReadOnly]="true" [header]="'備考'" [binding]="'Remarks'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input *ngIf="model.isEditableColumnSuggestList; else elseBlock" type="text"
              [disabled]="model.isDisableGridColumnsSuggestList"
              class="text-label-normal embedded-input" [maxlength]="256" [tabindex]="0"
              [(ngModel)]="cell.item.Remarks" plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true">
            <ng-template #elseBlock>
              <div>{{cell.item.Remarks}}</div>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>

    <button #btn_CancelSelection id="btn_CancelSelection" class="btn-tartiary" [tabindex]="0"
      [disabled]="model.isDisableButtonCancelSelection" (click)="eventCancelSelection_CLICKHandler()">
      選定解除</button>
  </div>
</div>

<footer class="footer-buttons">
  <button id="btn_SuggestionGoodsListOutput" class='btn-secondary' [disabled]="model.isDisableButtonOutput"
    [tabindex]="0" forcedEnabledMode="true" (click)="eventSuggestionGoodsListOut_CLICKHandler()">提案商品一覧出力</button>
  <button id="btn_SaveTemporary" class='btn-secondary' [disabled]="model.isDisableButtonSaveTemporary" [tabindex]="0"
    (click)="eventSaveTemporary_CLICKHandler()">一時保存</button>
  <button id="btn_Suggest" class='btn-primary' [disabled]="model.isDisableButtonSuggest" [tabindex]="0"
    (click)="eventSuggest_CLICKHandler()">提案</button>
</footer>